import type {RenderAugmentation, RenderModifier, RenderRule} from "./types";
import RenderNodeFactory from "./RenderNodeFactory";

/**
 * Positional-args wrapper around RenderNodeFactory.
 * The dokumentgenerator package calls renderNodeFactory(rules, augmentations, modifiers)
 * with positional arguments. Our RenderNodeFactory uses a single object argument.
 */
const RenderNodeFactoryLegacy = (
    ruleset: RenderRule[] = [],
    augmentations: RenderAugmentation[] = [],
    modifiers: RenderModifier[] = []
) => RenderNodeFactory({ruleset, augmentations, modifiers});

export default RenderNodeFactoryLegacy;
